export const SET_WEBSITE_STYLES = 'SET_WEBSITE_STYLES'
export const SET_WEBSITE_THEMES_LIST = 'SET_WEBSITE_THEMES_LIST'
export const SET_WEBSITE_THEME = 'SET_WEBSITE_THEME'
export const SET_WEBSITE_SETTINGS = 'SET_WEBSITE_SETTINGS'
